import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'noBehaviourPlaceholder'
	| 'privateInstructionsTitle'
	| 'privateInstructionsDescription';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		noBehaviourPlaceholder: {
			id: 'rovo-chat.view-agent.no-behaviour-placeholder',
			defaultMessage: 'This agent has no custom behavior',
			description:
				'Empty state message displayed in the Behavior section of the agent details view when the agent has no custom behavior configured.',
		},
		privateInstructionsTitle: {
			id: 'rovo-chat.view-agent.hidden-instructions-title',
			defaultMessage: 'These instructions are private',
			description:
				'Section title shown in agent details when instructions are intentionally hidden from view (for code-built Forge agents that hide instructions for privacy).',
		},
		privateInstructionsDescription: {
			id: 'rovo-chat.view-agent.hidden-instructions-description',
			defaultMessage: 'Forge agents built with code have their instructions hidden for privacy.',
			description:
				'Explanatory text shown below the private instructions title. Explains why instructions are not visible - Forge agents built with code keep instructions hidden for privacy/security.',
		},
	});

export default message;
